/**
 * Combine passed props with a default set of props, and ensure that all properties have been set.
 * @param props
 * @param defaultProps
 * @returns
 */
export default function setDefaultProperties(props, defaultProps) {
    return Object.assign({}, defaultProps, props);
}
